"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListMultipartUploadsInput_1 = require("./ListMultipartUploadsInput");
var ListMultipartUploadsOutput_1 = require("./ListMultipartUploadsOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.ListMultipartUploads = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "ListMultipartUploads",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?uploads"
    },
    input: {
        shape: ListMultipartUploadsInput_1.ListMultipartUploadsInput
    },
    output: {
        shape: ListMultipartUploadsOutput_1.ListMultipartUploadsOutput
    },
    errors: []
};
//# sourceMappingURL=ListMultipartUploads.js.map